import { render, staticRenderFns } from "./ChiTietLoiNhuan.vue?vue&type=template&id=0523de2a&scoped=true&"
import script from "./ChiTietLoiNhuan.vue?vue&type=script&lang=js&"
export * from "./ChiTietLoiNhuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523de2a",
  null
  
)

export default component.exports